import { KeyValuePipe, NgClass, NgForOf, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { AdminService } from '../../admin/admin.service';
import { DataToolsLiteMessage } from '../../shared/DataToolsLiteMessage';
import { DatatoolsLiteService } from '../../shared/services/datatools-lite.service';
import { DataCleanerSearch, IGroupedSearches } from '../models/data-cleaner-search.model';
import { PreviousSearchesBurgerService } from './previous-searches-burger.service';

@Component({
  selector: 'app-previous-searches-burger',
  templateUrl: './previous-searches-burger.component.html',
  imports: [
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    NgSwitch,
    NgSwitchCase,
    MatTooltip,
    NgIf,
    NgForOf,
    FormsModule,
    NgClass,
    KeyValuePipe
  ],
  styleUrls: ['./previous-searches-burger.component.scss']
})
export class PreviousSearchesBurgerComponent {

  @Input() groupedSearches: IGroupedSearches;
  @Output() reportSearch = new EventEmitter<DataCleanerSearch>();
  @Output() deleteSearch = new EventEmitter<DataCleanerSearch>();
  searchGroupsOrder = ['RUNNING', 'QUEUED', 'SCHEDULED', 'COMPLETED'];

  constructor(public adminService: AdminService,
              private router: Router,
              private previousSearchesBurgerService: PreviousSearchesBurgerService,
              private datatoolsLiteService: DatatoolsLiteService) {
  }

  get previousSearchesBurgerOpen() {
    return this.previousSearchesBurgerService.previousSearchBurger;
  }

  set previousSearchesBurgerOpen(v) {
    if (this.adminService.isInLiteMode()) {
      // TODO: These messages aren't actually shown now - we have the image instead
      this.datatoolsLiteService.triggerMessage$.next(DataToolsLiteMessage.DATACLEANER_PREVIOUS_SEARCHES);
      return;
    }
    this.previousSearchesBurgerService.previousSearchBurger = v;
  }

  setReportSearch(item: DataCleanerSearch) {
    this.previousSearchesBurgerService.closePreviousSearchesBurger();
    this.reportSearch.emit(item);
  }

  setDeleteSearch(item: DataCleanerSearch) {
    this.deleteSearch.emit(item);
  }

}
